import { ItemOption } from 'components/FormInputSelect'
import { useCallback, useEffect, useState } from 'react'
import genericService from 'services/generic.service'

export const useFamiliarReferenceOptions = () => {
  const [familiarReferenceOptions, setFamiliarReferenceOptions] = useState<ItemOption[]>([])

  const fillReferencesTypes = useCallback(async (): Promise<void> => {
    try {
      const res = await genericService.get('/tipo-referencia')
      if (res) {
        setFamiliarReferenceOptions(res.data)
      }
    } catch (error) {
      console.error('Familiar Reference Request:', error)
    }
  }, [setFamiliarReferenceOptions])

  useEffect(() => {
    fillReferencesTypes()
  }, [fillReferencesTypes])

  return familiarReferenceOptions
}
